import {Helmet} from "react-helmet-async";

import {useDateRange} from "@/components/datePicker/DatePickerURLRangeParamsContext.ts";
import {Last30Days} from "@/components/datePicker/subComponents/DatePickerShortcutList/DatePickerShortcutList.utils.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {DEFAULT_OFFSET_KEY} from "@/lib/hooks/usePagination.ts";
import {IncidentsActionBar} from "@/pages/incidents/IncidentsActionBar.tsx";
import {IncidentsList} from "@/pages/incidents/IncidentsList.tsx";

export const INCIDENTS_RANGE_KEY_FROM = "range_from";
export const INCIDENTS_RANGE_KEY_TO = "range_to";
export const INCIDENTS_FIXED_RANGE_KEY = "range";

export const IncidentsPage = () => {
  const {dateRange, fixedRangeOption, handleRangeChange} = useDateRange({
    fromKey: INCIDENTS_RANGE_KEY_FROM,
    toKey: INCIDENTS_RANGE_KEY_TO,
    fixedRangeKey: INCIDENTS_FIXED_RANGE_KEY,
    withDefault: Last30Days,
    clearKeysOnRangeChange: [DEFAULT_OFFSET_KEY],
  });

  return (
    <UpErrorBoundary
      fallback={
        <ContentContainer title="Incidents">
          <ErrorFallback />
        </ContentContainer>
      }
    >
      <ContentContainer
        title="Incidents"
        actionsBar={
          <IncidentsActionBar
            visibleRange={dateRange}
            onVisibleRangeChange={handleRangeChange}
            fixedRange={fixedRangeOption?.value}
          />
        }
      >
        <Helmet>
          <title>Incidents</title>
        </Helmet>
        <IncidentsList visibleRange={dateRange} />
      </ContentContainer>
    </UpErrorBoundary>
  );
};
